/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')
require('@fortawesome/fontawesome-free/css/all.min.css')
import store from './store/index'
import Vue from 'vue'
import Vuex from 'vuex'

//window.Vue = require('vue');
var moment = require('moment')

//import Vuex from 'vuex';
import 'es6-promise/auto'

import { Lang } from 'laravel-vue-lang'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuex)

import ValidatorMessagesDe from 'vee-validate/dist/locale/de'
import ValidatorMessagesFr from 'vee-validate/dist/locale/fr'
import VeeValidate, { Validator } from 'vee-validate'

if (window.locale != 'de' && window.locale != 'en' && window.locale != 'fr') {
  window.locale = 'de'
}

// a new custom validator function, that says a field is required if another field value is not empty
Validator.extend(
  'required_if_not_empty',
  (value, [otherValue]) => {
    return {
      valid: value != '',
      data: {
        required: otherValue != '',
      },
    }
  },
  {
    hasTarget: true,
    computesRequired: true,
  }
)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.use(Lang, {
  /*	locale: 'de', */
  fallback: 'de',
})

Vue.use(VeeValidate, {
  locale: window.locale,
  // This is the default
  inject: true,
  // Important to name this something other than 'fields'
  fieldsBagName: 'veeFields',
  // This is not required but avoids possible naming conflicts
  errorBagName: 'veeErrors',
})

Vue.prototype.$enableLoadingAnimation = window.enableLoadingAnimation
Vue.prototype.$disableLoadingAnimation = window.disableLoadingAnimation

if (window.locale == 'de') {
  Validator.localize(window.locale, ValidatorMessagesDe)
}
if (window.locale == 'fr') {
  Validator.localize(window.locale, ValidatorMessagesFr)
}

Vue.component('main-page', require('./components/MainPage.vue').default)
Vue.component('profile-nav', require('./components/Header/ProfileNavigationComponent.vue').default)
Vue.component('floating-action-button', require('./components/FloatActionButton.vue').default)
Vue.component('footer-component', require('./components/Footer/FooterComponent.vue').default)
Vue.component('footer-success', require('./components/Footer/NewsletterSuccess.vue').default)
Vue.component('footer-error', require('./components/Footer/NewsletterError.vue').default)

const app = new Vue({
  data: {
    ready: false,
  },
  el: '#app',
  store: store,
})
